import React, { useState } from "react";
import { Link, Icon } from "@telia/teddy";

import { ModalDialog } from "../../../../components";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../../../../../models";
import { selectors as AUTH_SELECTORS } from "../../../../authentication";
import { resetOrder } from "../../../../checkout/state/actions/phoneNumberActions";
import TEXT from "../../../text-consts";
import BackLink from "../../atoms/BackLink/BackLink";

interface Props {
    isBankIdVerified: boolean;
}

const ConfirmIdBackButton: React.FC<Props> = ({ isBankIdVerified }) => {
    const [showLogOutBankIdModal, setShowLogoutBankIdModal] = useState(false);
    const dispatch = useDispatch();

    if (!isBankIdVerified) {
        return <BackLink href="/mobil/hjelp/bytte-eier/" text={TEXT.COMMON.BACK} />;
    }
    return (
        <>
            <Link
                variant="standalone"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    setShowLogoutBankIdModal(true);
                }}
            >
                <Icon name="arrow-left" />
                {TEXT.COMMON.BACK}
            </Link>
            {showLogOutBankIdModal && (
                <ModalDialog
                    className="confirm-id__logout-bankid"
                    size="small"
                    submitText="Ja, logg meg ut"
                    closeText="Nei, bli på siden"
                    closeKind="secondary"
                    heading="Ønsker du å logge ut av BankID?"
                    name="log-out-bank-id-modal"
                    onSubmit={() => {
                        dispatch(resetOrder());
                        setShowLogoutBankIdModal(false);
                    }}
                    onClose={() => setShowLogoutBankIdModal(false)}
                ></ModalDialog>
            )}
        </>
    );
};

const mapStateToProps = (state: RootState): Props => ({
    isBankIdVerified: AUTH_SELECTORS.isBankIdVerified(state),
});

export default connect(mapStateToProps)(ConfirmIdBackButton);
